import React, { Component, PropTypes } from 'react';
import ComponentTitle from '../shared/ComponentTitle';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';

class TwitterFeed extends Component {
    static propTypes = {
        title: PropTypes.string,
        screenName: PropTypes.string,
        widgetId: PropTypes.string,
        titleType: PropTypes.string
    };

    static defaultProps = {
        title: '',
        screenName: '',
        widgetId: '',
        titleType: TITLE_TYPE.MODULE_TITLE
    }

    componentDidMount() {
        /* eslint-disable */

        window.twttr = (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0],
                t = window.twttr || {};
            if (d.getElementById(id)) return t;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function (f) {
                t._e.push(f);
            };

            return t;
        } (document, "script", "twitter-wjs"));

        /* eslint-enable */
    }

    render() {
        const { title, screenName, widgetId, titleType } = this.props;

        return (
            <div className="TwitterFeed">
                <ComponentTitle titleType={titleType} title={title} classes="TwitterFeed-header" />
                <div id="TwitterFeed-container"></div>
                <a className="twitter-timeline"
                    data-widget-id={widgetId}
                    data-screen-name={screenName}
                    data-chrome="noheader nofooter noborders noscrollbar"
                    data-tweet-limit="3">
                </a>
            </div>
        );
    }
}

export default TwitterFeed;



// WEBPACK FOOTER //
// ./app/components/social/TwitterFeed.js